/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import { Container } from 'react-bootstrap';
import { SteppedNavigationProps } from './types';
import { ReactComponent as StepIcon } from '../../assets/Stepper.svg';

const SteppedNavigation = (props: SteppedNavigationProps) => {
    const {
        activeStep,
        steps,
        id,
        interactive,
    } = props;

    const firstNotCompleted = steps.findIndex((x) => !x.completed);

    return (
        <Container role='presentation' data-testid={id} aria-hidden='true'>
            <h2 id='step-nav' className='visually-hidden'>Form progress</h2>
            <ul className='stepped-navigation' aria-labelledby='step-nav'>
                {steps.map((step, index) => {
                    const active = activeStep === index;
                    const clickable = (firstNotCompleted === -1) || (firstNotCompleted >= index);
                    return (
                        <li
                            key={`stepnav-${index.toString()}`}
                            className={step.completed ? (active ? 'current-step completed-step' : 'completed-step') : (active ? 'current-step' : '')}
                            aria-current={active}
                        >
                            <div className='step-container'>
                                {
                                    (interactive && clickable && !active)
                                        ? (
                                            <>
                                                <a href={step.path} className='step-icon'>
                                                    <StepIcon />
                                                    <span className='step-number'>{index + 1}</span>
                                                </a>
                                                <a href={step.path} className='step-name'>
                                                    {step.title}
                                                </a>
                                            </>
                                        )
                                        : (
                                            <>
                                                <div className='step-icon'>
                                                    <StepIcon />
                                                    <span className='step-number'>{index + 1}</span>
                                                </div>
                                                <div className='step-name'>
                                                    {step.title}
                                                </div>
                                            </>
                                        )
                                }
                                <span className='visually-hidden'>
                                    {step.completed
                                        ? (active ? 'current and completed ' : 'completed ')
                                        : 'not completed'}
                                </span>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </Container>
    );
};

export default SteppedNavigation;
